<template>
  <div class="bar-chart-container" style="background: none">
    <v-chart
      :options="option"
      :autoresize="true"
      id="bar-chart"
      style="background: yellow"
    ></v-chart>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import { mapGetters } from "vuex";

export default {
  name: "ChartTime",

  data() {
    return {
      option: {},
      maxGraph: 0
    };
  },
  components: {
    "v-chart": ECharts
  },
  computed: {
    ...mapGetters(["getActivityPerCategory"])
  },
  methods: {
    drawGraph() {
      this.option = {
        color: ["#5696fc", "#b9d4ff", "#d2dceb", "eaf2ff", "#fff"],
        calculable: true,
        cursor: "auto",
        backgroundColor: "#383838",
        grid: {
          show: false,
          left: "3%",
          right: "3%",
          top: "0%",
          bottom: "1%",
          width: "95%",
          height: "94%",
          containLabel: true
        },
        xAxis: {
          show: true,
          type: "category",
          data: [
            "00",
            "",
            "",
            "03",
            "",
            "",
            "06",
            "",
            "",
            "09",
            "",
            "",
            "12",
            "",
            "",
            "15",
            "",
            "",
            "18",
            "",
            "",
            "21",
            "",

            "23"
          ],
          color: "#fff",
          boundaryGap: false,
          min: 0,
          max: 23,
          scale: false,
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#aaa",
              type: "dashed",
              width: 1,
              shadowBlur: 3
            }
          },

          axisLabel: {
            show: true,
            interval: 0,
            color: "#aaaaaa",
            margin: 12
          }
        },
        yAxis: {
          type: "value",
          label: { show: false },
          offset: 15,

          boundaryGap: false,

          min: 0,
          max: this.maxGraph + 9,
          splitNumber: 6,
          axisLine: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#747474",
              type: "dashed",
              width: 1
            }
          },

          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          markPoint: {
            data: [
              {
                data: [{ type: "average", name: "avg" }]
              }
            ],
            symbolSize: 1,
            symbol: "rect"
          }
        },

        series: [
          {
            name: "Football",
            type: "bar",
            stack: "xx",
            markPoint: {
              data: [
                {
                  name: "maximum",
                  type: "max"
                }
              ],
              symbol: "rect",
              label: {
                show: true
              }
            },

            data: this.getActivityPerCategory[0]
          },
          {
            // Skyblue1 Hokey
            name: "Hokey",
            type: "bar",
            stack: "xx",

            data: this.getActivityPerCategory[1]
          },
          {
            // Skyblue2 Bootcamp
            name: "Fitness",
            type: "bar",
            stack: "xx",
            data: this.getActivityPerCategory[2]
          }
        ]
      };
    },

    largest(a, b, c) {
      return Math.max.apply(null, [a, b, c]);
    }
  },
  watch: {
    getActivityPerCategory() {
      let maxFootball = 0;
      let maxHockey = 0;
      let maxFitness = 0;
      maxFootball = Math.max.apply(null, this.getActivityPerCategory[0]);
      maxHockey = Math.max.apply(null, this.getActivityPerCategory[1]);

      maxFitness = Math.max.apply(null, this.getActivityPerCategory[2]);
      this.maxGraph = this.largest(maxFootball, maxHockey, maxFitness);

      this.drawGraph();
    }
  }
};
</script>

<style>
.bar-chart-container {
  padding: 0;
  margin: 0;
  height: 350px;
}

#bar-chart {
  display: flex;
  flex-direction: row;
  width: inherit;
  height: inherit;
}

#bar-chart > div {
  display: flex;
  width: inherit;
}

.chart-container:hover {
  cursor: default;
}
</style>
